import React, { createContext, useContext, useLayoutEffect, useState } from 'react';
import { applyDarkModeOverrides, removeDarkModeOverrides, applyDarkModePrimaryOverride, restoreLightPrimary } from './BrandingContext';

const ThemeContext = createContext(null);

const STORAGE_KEY = 'cc-theme';

function getInitialTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'dark' || saved === 'light') return saved;
  } catch {}
  return 'light';
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);

  // useLayoutEffect ensures data-theme is set on the DOM before BrandingProvider's
  // useEffect fires, so BrandingProvider can correctly apply dark overrides on top
  // of its branding tokens in the same render cycle.
  useLayoutEffect(() => {
    const root = document.documentElement;
    root.dataset.theme = theme;
    if (theme === 'dark') {
      applyDarkModeOverrides(root);
      applyDarkModePrimaryOverride(root); // no-op on first load; active on toggle
    } else {
      removeDarkModeOverrides(root);
      restoreLightPrimary(root);
    }
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch {}
  }, [theme]);

  function toggleTheme() {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }

  return (
    <ThemeContext.Provider value={{ theme, isDark: theme === 'dark', toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
}
